import * as Joi from "joi";

export const EducationInfoSchema = Joi.object({
  course: Joi.string().required('Please select an option'),
  workExperience: Joi.string().required(),
  academics: Joi.string().required(),
  targetedCountries: Joi.array().items(Joi.string().required()),
  targetIntake: Joi.string().required('Please select an option'),
  examTime: Joi.string().required('Please select an option'),
}).options({ abortEarly: false });